import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/background-for-desktop.png")